<template>
  <div>

      <el-row>
          <div v-if="isTelco()" style="padding-top: 1.25em; padding-bottom: 0.75em;">
            <el-switch
              style="display: block"
              size="small"
              v-model="showAllSites"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-text="'All ' + towerName + ' Sites (' + (this.getStats() ?  this.getStats().availableSites : 'N/A') + ')'"
              :inactive-text="'Only ' + orgName + ' Sites (' + (this.getStats() ?  this.sharerMarkers : 'N/A') + ')'"
              :disabled="disabled"
              @change="resetSearch">
          </el-switch>
        </div>

        <div v-else style="padding-top: 1.75em;"></div>
      </el-row>

    <el-form label-position="left">

      <el-row :gutter="9">

        <el-col v-if="!editLatLng" :sm="24" :md="12" :lg="8" align="left">
          lat: <b>{{formatNumber(this.search.lat, 12)}}</b> | lng:<b> {{formatNumber(this.search.lng, 12)}}</b>
          &nbsp;<el-button size="mini" type="primary" plain icon="fa fa-edit" @click="editLatLng = true" :disabled="disabled" />
        </el-col>

        <el-col v-else :sm="24" :md="12" :lg="8" align="center">
          <float-input
            prefix="Lat."
            suffix="&deg;"
            v-model="search.lat"
            :size="size"
            :decimals="17"
            placeholder="Latitude"
            :disabled="disabled" />

          <float-input
            prefix="Lng."
            suffix="&deg;"
            v-model="search.lng"
            :size="size"
            :decimals="17"
            placeholder="Longitude"
            :disabled="disabled" />
        </el-col>

        <el-col :sm="24" :md="12" :lg="8" align="right">
          <el-tooltip content="Radius" :placement="pl">
          <el-slider
            v-model="search.radius"
            prefix="Radius"
            suffix="km."
            :min="1"
            :max="20"
            show-input
            :size="size"
            placeholder="Radius"
            :disabled="disabled" />
          </el-tooltip>

        </el-col>

      </el-row>


      <el-row :gutter="9">

        <el-col  :sm="24" :md="12" :lg="8" align="left">

          <el-tooltip content="Zoom Level" :placement="pl">
            <select-input
            :size="size"
            v-model="search.zoom"
            :list="zoomLevel"
            style="margin-top: -8px;"
            :disabled="disabled" />

          </el-tooltip>
        </el-col>

        <el-col  :sm="24" :md="12" :lg="8" align="center">
          <el-tooltip content="Map Style" :placement="pl">

            <el-select v-model="styleType" :size="size" :disabled="disabled">
              <el-option label="Discreet" value="discreet" />
              <el-option label="Elevation" value="elevation" />
              <el-option label="Light Grey" value="grey" />
              <el-option label="Jade" value="jade" />
              <el-option label="Jamie" value="jamie" />
              <el-option label="Muted Blue" value="mutedblue" />
              <el-option label="Outspoken" value="outspoken" />
              <el-option label="Flat Pale" value="flatpale" />
            </el-select>

          </el-tooltip>
        </el-col>

        <el-col  :sm="24" :md="12" :lg="8">
          <el-form-item class="pull-right">
            <el-button-group>
              <el-button type="primary" :size="size" icon="fa fa-search" @click="geoSearch" :disabled="disabled">Search</el-button>
              <el-button type="info" :size="size" icon="fa fa-times-circle" @click="resetSearch" :disabled="disabled"></el-button>
            </el-button-group>
          </el-form-item>
        </el-col>

      </el-row>

    </el-form>



    <el-row type="flex" justify="center">

      <el-col align="left">
        <el-tooltip content="Show/Hide Moveable Search Marker">

          <el-switch v-model="showMarker"
          :size="size"
          active-icon-class="fa fa-map-marker"
          inactive-icon-class="fa fa-map-marker-alt"
          :disabled="disabled" />
        </el-tooltip>

        &nbsp;

        <el-tooltip content="Show/Hide Radius Circle">
          <el-checkbox v-model="showCircle" :size="size" :disabled="disabled">
            <i :class="showCircle ? 'fa fa-plus-circle'
            : 'fa fa-minus-circle'"></i>
          </el-checkbox>
        </el-tooltip>

        &nbsp;

        <el-tooltip content="Show/Hide Nearby Points of Intrest">
          <el-checkbox v-model="showPoi" :size="size" disabled>
            <i :class="showPoi ? 'fa fa-map-signs'
            : 'fa fa-trash-alt-location'"></i>
          </el-checkbox>
        </el-tooltip>

      </el-col>

      <el-col :span="18" align="center">
        <div v-if="showProgress">
          <el-progress :text-inside="true" :stroke-width="18" :percentage="progress"></el-progress>
        </div>

        <div v-else>
          <div v-if="showLegend">
            <el-col v-if="leg.title" :span="6">
              <span class="text-muted">{{leg.title}}</span>
            </el-col>

            <el-col align="center" v-for="(l, i) in leg.legend" :key="l.siteId">
              <span class="text-muted"><img :src="i.icon"> {{i.label}}</span>
            </el-col>
          </div>
        </div>

      </el-col>


      <el-col align="right">
        <el-tooltip content="Reset &amp; Center Map">
          <el-button type="success" :size="size" icon="fa fa-arrows-alt" @click="resetMap()" :disabled="disabled" />
        </el-tooltip>
      </el-col>

  </el-row>


  <el-row>
    <el-col :span="24">

      <gmap-map
          ref="xolasMap"
          :center="search"
          :options="{styles: style}"
          :zoom="search.zoom"
          map-type-id="terrain"
          style="width: 100%; height: 52.8vh;">

        <gmap-marker
            v-if="showMarker"
            :position="search"
            :clickable="true"
            :draggable="true"
            :icon="dragIcon()"
            @dragend="updatePos">
        </gmap-marker>

        <gmap-circle v-if="showMarker && showCircle"
          :center="{lat: Number(this.search.lat), lng: Number(this.search.lng)}"
          :radius="Number(this.search.radius / 6.5) * this.search.km"
          :options="mapCenterOptions">
        </gmap-circle>

        <gmap-marker
          v-for="m in markers" :key="m.content.id"
          :position="m.position"
          :clickable="true"
          :icon="mapIcon(leg.prop, m)"
          @click="center=m.position"
          @mouseover="legendStatus(m)"
          @mouseout="statusText = null"
          @mousedown="m.visible=true">

          <gmap-info-window
            :opened="m.visible"
            @closeclick="m.visible=false">

            <center>
              <strong>{{m.content.siteName}}</strong> <span v-if="isTowerCo()">[{{m.content.licenees}}]</span>
              <br>

              <div v-show="m.content.siteId">
                <small>{{m.content.siteId}}</small>
                <br>
              </div>

              <div v-show="m.content.structureType">
                <small>{{m.content.structureType}} <span v-if="m.content.structureHeight">({{m.content.structureHeight}}m)</span></small>
                <br>
              </div>
            <!--      <el-button v-if="isTowerCo()" @click="viewSite(m.content.siteId)" type="primary">View</el-button> -->
              <div v-if="isTowerCo()">
                <br>
                <span v-if="m.content.handover"><small>Handover</small> <i>{{m.content.handover}}</i></span>  <i v-if="m.content.status">{{m.content.status}}</i>
              </div>
            <!--            <request-share-action :siteId="m.content.id" />
            <ticket-action buttonSize="small" :row-data="{}" />  -->
          </center>
        </gmap-info-window>

        </gmap-marker>

        <div slot="visible">
          <div style="bottom: 0; left: 0; background-color: slategrey; text-align: center; color: ivory; width: 100%; position: absolute; z-index: 100">
            {{statusText}}
          </div>
        </div>
      </gmap-map>

      </el-col>
    </el-row>

    <el-collapse v-model="menu" accordion>

      <el-collapse-item name="nearby" v-if="showPoi">
          <template slot="title">
            <i class="header-icon fa fa-map">&nbsp;</i>Nearby Places
          </template>

          <nearby-places :lat="search.lat" :lng="search.lng" :radius="search.radius" />

      </el-collapse-item>

      <el-collapse-item v-if="showSites" name="sites">
          <template slot="title">
            <i class="header-icon fa fa-broadcast-tower">&nbsp;</i>Sites
          </template>
            <sites-table
              v-if="this.totalMapMarkers > 0"
              :title="'Map Search Sites (' + formatInteger(isTelco() ? this.sharerMarkers : this.totalMarkers) + ')'"
              :geo-search="search"
              :sharer="sharerId"
              condensed
              :show-map="false" />
        </el-collapse-item>

  </el-collapse>

  </div>

</template>


<script>

import Vue from 'vue'
import VueEvents from 'vue-events'

import {GOOGLE_API_KEY, MAP_SEARCH_EVENT, MAP_RESET_EVENT} from '@/components/Data'

import {disrcreetMapStyle, elevationMapStyle, jadeMapStyle, jamieMapStyle,
    lightGreyMapStyle, outspokenMapStyle, mutedBlueMapStyle, flatPaleMapStyle} from '@/components/maps/styles/GoogleMapStyles'


import ArrayMixins from '@/mixins/ArrayMixins'
import GoogleMapMixins from '@/mixins/GoogleMapMixins'

import * as GMap from 'gmap-vue'

import NearbyPlaces from '@/components/maps/NearbyPlaces'
import SitesTable from '@/components/tables/SitesTable'

Vue.use(GMap, {
  load: {
    key: GOOGLE_API_KEY,
    libraries: 'places'
  }
})

Vue.use(VueEvents)


export default {
  mixins: [ArrayMixins, GoogleMapMixins],


  components: {
    SitesTable,
    NearbyPlaces
  },


  props: {
    sharer: {
      type: Number,
      default: null
    },

    showLegend: {
      type: Boolean,
      default: true
    },

    showSites: {
      type: Boolean,
      default: true
    },

    legend: {
      type: Object,
      required: true
    },

    zoom: {
      type: Number,
      default: 11
    },

    mapStyle: {
      type: String,
      validator: function (value) {
        return value !== null ? ['discreet', 'elevation', 'grey', 'jade', 'jamie', 'outspoken', 'mutedblue', 'flatpale'].indexOf(value) !== -1 : true
      },
      default: 'grey'
    }
  },



  methods: {

    updateProgress (progress) {
      this.progress = progress.percent
      this.totalMapMarkers = progress.total
    },


    loadingFinished () {
      this.showProgress = false
      this.disabled = false
      this.resetMap()

      if (this.showPoi) {
        this.loadPoi(this.search.lat, this.search.lng, this.search.radius)
      }
    },


    updatePos (e) {
      this.search.lng = e.latLng.lng()
      this.search.lat = e.latLng.lat()
    },


    resetMap () {

//      console.log('map ref', this.$refs.xolasMap.$mapObject)

      if (this.bounds && this.bounds.isEmpty()) {
        this.resetBounds()

//        this.search.lat = Number(this.center.lat)
//        this.search.lng = Number(this.center.lng)

        let position = {lat: this.search.lat, lng: this.search.lng}
        this.bounds.extend(position)

      }

      this.$refs.xolasMap.panToBounds(this.bounds)
      this.$refs.xolasMap.fitBounds(this.bounds)
    },


    viewSite (siteId) {
      this.$root.$data.routes.push({name: 'site', params: { id: siteId }})
    },



    geoSearch () {
      this.editLatLng = false
      this.disabled = true

      this.resetBounds()
//      console.log('search', this.search.lat, this.search.lng)

      var rawUrl = '/sites/map/' + this.search.lat + '/' + this.search.lng + '/' + this.search.radius
      rawUrl + this.showAllSites ? '' : (this.sharerId ? '/km/60/' + this.sharerId : '')

      var url = this.getEndpoint(rawUrl)

      this.$events.fire(MAP_SEARCH_EVENT, this.search)
      this.loadMapMarkers(url, this.bounds)

    },

    resetSearch () {

      this.editLatLng = false

      this.resetBounds()

//      this.search.lat = Number(this.center.lat)
//      this.search.lng = Number(this.center.lng)

//        var rawUrl = '/sites/map/null/null/nulll/km/60'
      var url = this.getEndpoint(this.defaultUrl)
      this.$events.fire(MAP_RESET_EVENT)

      this.loadMapMarkers(url, this.bounds)
    },

    mapIcon (prop, m) {
      if (m && m.content) {
        return this.leg.mapIcon(m.content[prop])
      } else {
        return this.defaultIcon()
      }
    },


    legendStatus (m) {
      this.statusText = 'No status found.'

      if (this.leg && this.leg.statusFormatter && this.isFunction(this.leg.statusFormatter)) {
        this.statusText = this.leg.statusFormatter(m)
      }

      return this.statusText
    },

    getMapStyle (style = null) {

      let s = style ? style : this.styleType
      s = this.findInList('name', s, this.mapStyles)
      return s ? s.style : null
    },


    sharerChange (val) {
      this.sharerId = val === 0 ? null : Number(val)
      this.loadMapMarkers(this.getEndpoint(this.defaultUrl), this.bounds)
    }

  },



  watch: {

    sharer: function (value) {
      this.sharerId = value
    },

    styleType: function (value) {
      this.style = this.getMapStyle(this.styleType)
    }

  },


  computed: {

    defaultUrl: function () {
      let u = '/view/map' + (this.showAllSites ? '/all' : (this.sharerId ? '/org/' + this.sharerId : ''))
      return u
    }

  },



  data () {

    return {
      menu: 'sites',
      pl: 'left',
      sharerId: this.sharer,
      leg: this.legend,

      activePane: 'map',
      size: 'mini',
      totalMapMarkers: 0,

      towerName: this.xolasClient().shortName
      ? this.xolasClient().shortName
      : this.xolasClient().name,

      orgName: this.org().shortName
      ? this.org().shortName
      : this.org().name,

      statusText: null,

      showAllSites: false,
      selectView: null,
      showMarker: false,
      showCircle: true,
      showPoi: false,
      disabled: true,

      zoomLevel: [
        {label: 'World', value: 1},
        {label: 'Continent', value: 5},
        {label: 'Country', value: 7},
        {label: 'Region', value: 9},
        {label: 'State', value: 11},
        {label: 'City', value: 13},
        {label: 'Streets', value: 15},
        {label: 'Buildings', value: 20}
      ],

      mapStyles: [
        {name: 'discreet', style: disrcreetMapStyle},
        {name: 'elevation', style: elevationMapStyle},
        {name: 'jade', style: jadeMapStyle},
        {name: 'jamie', style: jamieMapStyle},
        {name: 'grey', style: lightGreyMapStyle},
        {name: 'outspoken', style: outspokenMapStyle},
        {name: 'mutedblue', style: mutedBlueMapStyle},
        {name: 'flatpale', style: flatPaleMapStyle}
      ],

      center: this.getStore().baseMap,
      styleType: this.mapStyle,
      style: null,

      searchEnabled: false,
      showProgress: true,
      editLatLng: false,
      legendType: 'Sharers',
      progress: 0,

      search: {
        lat: this.getStore().baseMap.lat,
        lng: this.getStore().baseMap.lng,
        radius: 5,
        zoom: this.zoom,
        mi: 3963.1676,
        km: 6378.1,
        ft: 20925524.9,
        mt: 6378100,
        fa: 3487587.49,
        na: 3443.89849,
        ch: 317053.408,
        rd: 1268213.63,
        fr: 31705.3408
      },

      mapCenterOptions: {
        strokeColor: 'indianred',
        strokeOpacity: 0.432,
        strokeWeight: 2,
        fillColor: 'indianred'
      }

    }
  },


  created () {
    this.style = this.getMapStyle(this.mapStyle)
  },

  mounted () {

    this.towerName = this.xolasClient().shortName
    ? this.xolasClient().shortName
    : this.xolasClient().name

    this.orgName = this.org().shortName
    ? this.org().shortName
    : this.org().name

    if (typeof this.orgName === 'undefined' || this.orgName === this.towerName) {
      this.orgName = 'Telco'
    }

    this.$events.listen('progress', perecent => this.updateProgress(perecent))
    this.$events.listen('finished', this.loadingFinished)

    this.loadMapMarkers(this.getEndpoint(this.defaultUrl), this.bounds)
  },

  beforeDestroy () {
    this.$events.remove('progress')
    this.$events.remove('finished')
  }

}
</script>
